module.exports = __webpack_public_path__ + "static/img/5.8bcd22e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/15/sp/5.png
// module id = iyVm
// module chunks = 0